import {CHANGE_SORT} from "../../actions/SortActions";
import {PARENT_FILTERS_CHANGED, RESET_ALL_FILTERS} from "../../actions/FlightsActions";

export const SORT_LOWEST_PRICE = 'price';
export const SORT_SHORTEST_FLIGHTS = 'shortest_flights';
export const SORT_DEPARTURE_TIME = 'departure';

const initialState = {
    field: SORT_LOWEST_PRICE,
};

const SortReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_SORT:
            return {...state, field: action.field};
        case PARENT_FILTERS_CHANGED:
            return {...state,
                field: action.filters.sort,
            };
        case RESET_ALL_FILTERS:
            return {...state, field: initialState.field};
        default:
            return state
    }
};

export default SortReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/SortReducer.js